import axios from 'axios';


const searchImages = async (term) => {
const response  = await axios.get('https://api.unsplash.com/search/photos',{
      headers: {
Authorization: 'Client-ID wR81lh7mfwVYR6y8vcvZ7DZ70El-H9TX2mXhQmlWCrI'
      },
      params:{
query:term,
      },
    });
  return response.data.results;
};

export default searchImages;